import BannerResilience from "../banner/BannerResilience";
import Footer from "../footer/Footer";
import Navigate from "../footer/Navigate";
import Header from "../header/Header";
import Adjustments from "./adjustments/Adjustments";
import Archetypes from "./archetypes/Archetypes";
import "./Resilience.scss";
import CommonBanner from "../banner/CommonBanner";
const Resilience = () => {
  return (
    <>
      <Header />
      <CommonBanner
        id="page2"
        titleDesktop="Pathway to"
        subtitle="Resilience"
      />
      <Adjustments />
      <Archetypes />
      <Navigate page="Ways to Connect" pagelink="/Connect" />
      <Footer />
    </>
  );
};

export default Resilience;
